import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import React from "react";
import { PageContainer } from "./PageContainer";
export var Divider = function(_param) {
    var _heading = _param.heading, heading = _heading === void 0 ? "" : _heading, animate = _param.animate, _className = _param.className, className = _className === void 0 ? "" : _className, rest = _object_without_properties(_param, [
        "heading",
        "animate",
        "className"
    ]);
    return /*#__PURE__*/ _jsx(PageContainer, _object_spread_props(_object_spread({}, rest), {
        children: heading ? /*#__PURE__*/ _jsxs("div", {
            className: classNames("flex justify-center items-center space-x-4 flex-row", className),
            children: [
                /*#__PURE__*/ _jsx(Line, {}),
                /*#__PURE__*/ _jsx("div", {
                    className: "font-medium tracking-widest flex-shrink-0 items-center",
                    children: heading
                }),
                /*#__PURE__*/ _jsx(Line, {})
            ]
        }) : /*#__PURE__*/ _jsx(Line, {})
    }));
};
function Line(porps) {
    return /*#__PURE__*/ _jsx("div", _object_spread({
        className: "w-full flex-auto border-t"
    }, porps));
}
